module.exports = __webpack_public_path__ + "static/media/customerSheet.13db37cf.xlsx";